import {Component} from '@angular/core';
import {DashboardService} from '../../shared/dashboardService';
import {MonitorStatusCount} from '../../shared/models/monitors';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectIncidents} from '../../shared/models/project';
import {Incident} from '../../shared/models/monitors-responses';
import {SkeletonTableComponent} from '../../components/common/skeleton-table/skeleton-table.component';
import {TableModule} from 'primeng/table';
import {Tooltip} from 'primeng/tooltip';
import {CommonModule, DatePipe} from '@angular/common';
import {DurationPipe} from '../../shared/pipes/duration-pipe/duration.pipe';
import {ContentWrapperComponent} from '../../shared/content-wrapper/content-wrapper.component';
import {EmptyComponent} from '../../pages/empty/empty.component';


@Component({
  selector: 'app-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  imports: [
    SkeletonTableComponent,
    TableModule,
    Tooltip,
    DatePipe,
    DurationPipe,
    [CommonModule],
    ContentWrapperComponent,
    EmptyComponent,
  ],
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  upCount: number = 0;
  downCount: number = 0;
  pausedCount: number = 0;
  projectId: string | null | undefined = null;
  monitorStatusData: MonitorStatusCount | null = null;
  incidentHeader: string[] = [];
  projectIncidents: ProjectIncidents[] = [];
  incidentsData: Incident[] = [];
  loading = true;
  expandedRows: { [key: string]: boolean } = {};

  constructor(
    private dashboardService: DashboardService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.incidentHeader = ['Project Name', 'Monitor Name', 'Root Cause', 'Started', 'Duration (HH:MM:SS)'];

    this.route.parent?.paramMap.subscribe(params => {
      this.projectId = params.get('projectId');

      if (this.projectId) {
        this.fetchData();
      }
    });
    this.fetchData()
  }

  fetchData() {
    this.monitorStatusCount();
    this.getOngoingProjectIncident();
    this.getOngoingIncidents();
  }

  getOngoingProjectIncident() {
    this.dashboardService.getOngoingProjectIncidents().subscribe({
      next: data => {
        this.projectIncidents = this.projectId ? data.filter(incident => incident.project.id.toString() === this.projectId) : data;

      },
      error: error => {
        console.log(error);
      },
      complete: () => {
      }
    })
  }

  monitorStatusCount() {
    const projectId = this.projectId ? Number(this.projectId) : undefined;
    this.dashboardService.getMonitorStatusCount(projectId).subscribe({
      next: data => {
        this.monitorStatusData = data;

        this.upCount = this.monitorStatusData?.upMonitorCount || 0;
        this.downCount = this.monitorStatusData?.downMonitorCount || 0;
        this.pausedCount = this.monitorStatusData?.pausedMonitorCount || 0;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getOngoingIncidents() {
    this.dashboardService.getOngoingIncidents().subscribe({
      next: (response) => {
        const {content, page} = response;
        this.incidentsData = this.projectId ? content.filter(incident => incident.id.toString() === this.projectId) : content;
        // this.page = page;
        this.loading = false;

      },
      error: error => {
        console.log(error);
      },
      complete: () => {
        this.loading = false;

      }
    })
  }

  navigateToIncidents() {
    console.log('navigateToIncidents');
    this.router.navigate(['/incidents']);
  }

  toggleRow(rowData: any): void {
    const key = rowData.id;
    this.expandedRows[key] = !this.expandedRows[key];
  }

  isRowExpanded(rowData: any): boolean {
    return this.expandedRows[rowData.id];
  }

  navigateToProject(projectId: number): void {
    this.router.navigate([`/projects/${projectId}`])
  }

  navigateToMonitor(projectId: number, monitorId: number) {
    this.router.navigate([`projects/${projectId}/monitors/${monitorId}`])
  }
}
